import { useAppSelector } from '@/libs/hooks/use-app-selector'

const ChangePinTemplateTitle = () => {
  const { partnerId } = useAppSelector((state) => state.user)
  return (
    <h1 className='text-center text-2xl font-semibold text-pop-neutral'>
      Set Up {partnerId ? 'New' : 'Responova'} PIN
    </h1>
  )
}

export default ChangePinTemplateTitle
